import { render, staticRenderFns } from "./LandingView.vue?vue&type=template&id=68abfd5a&scoped=true&"
import script from "./LandingView.vue?vue&type=script&lang=js&"
export * from "./LandingView.vue?vue&type=script&lang=js&"
import style0 from "./LandingView.vue?vue&type=style&index=0&id=68abfd5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68abfd5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VFlex,VImg,VLayout,VRow})
